<template>
  <div>

    <v-autocomplete
      label="Articles"
      clearable
      outlined
      full-width
      v-model="articleIdListener"
      :search-input.sync="searchArticle"
      :loading="loading"
      loader-height="5"
      :messages="loadingArticleMsg"
      :items="article_options"
    />

  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    page_title: {
      type: String,
      default: 'Article'
    },
    articleId: {
      type: Number,
      default () {
        return null
      }
    },
    articleTitle: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      search_query: '',
      loading: false,
      loading_message: 'Fetching Data',
      article_options: []
    }
  },
  methods: {
    ...mapActions({
      getArticles: 'article/geArticles'
    }),
    async fetchArticles (page = 1) {
      let params = { page }
      if (this.search_query || this.articleTitle) {
        params.search = this.search_query ? this.search_query : this.articleTitle
      }

      params.sort = '-created_at'
      params.article_filter = 'all'
      params.sport_filter = 'all'
      this.loading = true
      await this.getArticles(params)
      this.loading = false
    }
  },

  computed: {
    ...mapState({
      articles: state => state.article.list
    }),
    searchArticle: {
      get () {
        return this.search_query
      },

      set (searchInput) {
        if (this.search_query !== searchInput) {
          this.search_query = searchInput
          this.fetchArticles()
        }
      }
    },
    loadingArticleMsg () {
      let message = ''
      if (this.loading === true) {
        message = 'searching article. . .'
      }
      return message
    },
    articleIdListener: {
      get () {
        return this.articleId
      },
      set (val) {
        this.$emit('update:articleId', val)
      }
    }
  },
  watch: {
    articles: {
      immediate: true,
      handler (val) {
        if (val) {
          this.article_options = []
          val.forEach((value) => {
            this.article_options.push({
              text: value.title,
              value: value.id
            })
          })
        }
      }
    }
  },
  created () {
    this.fetchArticles()
  }
}
</script>

<style Scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
</style>
